// extracted by mini-css-extract-plugin
module.exports = {"view":"styles__view__ONhQF"};